import {ModifyOrganizationRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/ModifyOrganizationRequest';
import {AnOrganization} from '@mintdata-wsp/common/controllers/network/generated/responses/AnOrganization';
import {OrganizationResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/OrganizationResponse';
import {OrganizationsResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/OrganizationsResponse';
import {API} from '@mintdata-wsp/common/controllers/network/WorkspaceAPI';
import {Organization} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {action} from 'mobx';
import {IFormFieldState} from "@mintdata-wsp/common/components/formField/FormField";
import {Form, FormFieldValidationResult} from "@mintdata-wsp/common/components/form/Form";
import {Validators} from "@mintdata-wsp/common/components/validators/Validators";
import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';

export class OrganizationsController {

    public syncAllOrganizations():Promise<void>
    {
        return this.getAllForCurrentUser()
            .then(action((orgs: Organization[]) =>
            {
                rootState.data.organizations = orgs;
            }));
    }

    public create(req:ModifyOrganizationRequest):Promise<Organization>
    {
        return new Promise((resolve, reject) =>
        {
            return API.organizations.createOrganization(req)
                .then(action((resp: OrganizationResponse) =>
                {
                    if( resp instanceof ApiError )
                        reject(resp);
                    else
                    {
                        let org = Organization.fromAnOrganization(resp);
                        resolve(org);
                    }
                }));
        });
    }

    public update(sid:string, req:ModifyOrganizationRequest):Promise<Organization>
    {
        return new Promise((resolve, reject) =>
        {
            return API.organizations.updateOrganization(sid, req)
                .then(action((resp: OrganizationResponse) =>
                {
                    let org = Organization.fromAnOrganization(resp);
                    resolve(org);
                }));
        });
    }

    public getPublicOrganizations():Promise<Organization[]>
    {
        return API.organizations.getPublicOrganizations()
            .then((resp: OrganizationsResponse) =>
                resp.organizations.map(anOrg => Organization.fromResponse(anOrg))
            );
    }

    public getAllForCurrentUser():Promise<Organization[]>
    {
        return new Promise((resolve, reject) =>
        {
            API.organizations.getOrganizations()
                .then(action((resp: OrganizationsResponse) =>
                {
                    if (!(resp instanceof OrganizationsResponse))
                        throw new Error('No organizations for current user');

                    let orgs = resp.organizations.map((orgResp: AnOrganization) =>
                    {
                        return Organization.fromResponse(orgResp);
                    });

                    resolve(orgs);
                }));
        });
    }

    // public deleteOrganization(organization: Organization): Promise<any>
    // {
    //     return new Promise((resolve, reject) => {
    //         // API.organizations.delete(organization.id, design.id)
    //         //      .then(action(() =>
    //         //                  {
    //         //                  }));
    //     });
    // }

    public validateOrganizationName(value:string, state:IFormFieldState<string>, form?:Form):Promise<FormFieldValidationResult>
    {
        return Validators.validate({value, state, form, errorMessage: 'Please enter your organization name'},
            [
                Validators.serverError('organizationName'),
                Validators.emptyNotDirtyIsValid(),
                Validators.required(),
                Validators.minLength(4),
                Validators.maxLength(20),
            ]);
    }

    public validateOrganizationSiteId(value:string, state:IFormFieldState<string>, form?:Form):Promise<FormFieldValidationResult>
    {
        return Validators.validate({value, state, form, errorMessage: 'Please enter your organization domain'},
            [
                Validators.serverError('organizationSiteId'),
                Validators.emptyNotDirtyIsValid(),
                Validators.required(),
                Validators.regexp(/^[a-z0-9]+$/, 'Only "a-z 0-9" symbols are valid'),
                Validators.minLength(4),
                Validators.maxLength(32),
            ]);
    }
}
